/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterEvent, DataTablePageEvent, DataTableStateEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { SyntheticEvent, useEffect, useRef, useState } from "react";
import { BomCostingService } from "../../service/BomCostingService";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import RateDefault from "../../models/RateDefault";
import { InputNumber } from "primereact/inputnumber";
import CostElement from "../../models/CostElement";
import Factory from "../../models/Factory";
import { Calendar } from 'primereact/calendar';
import FormulaOption from "../../models/FormulaOption";
import SAPMaterialGroup from "../../models/SAPMaterialGroup";
import WorkCenter from "../../models/WorkCenter";
import LazyState from "../../models/LazyState";
import RateDefaultList from "../../models/RateDefaultList";
import { useMsal } from "@azure/msal-react";
import { Link } from "react-router-dom";
import { FormEvent } from "primereact/ts-helpers";

export default function RateDefaultView() {
    let emptyRD: RateDefault = {
        id: 0,
        styleCd: '',
        costElementId: 0,
        costElementDescription: '',
        formulaOptionId: 0,
        formulaOptionName: '',
        factoryId: 0,
        sapReference: '',
        materialGroupId: null,
        materialCapacityGroup: null,
        letterSize: null,
        numberOfColors: null,
        color: null,
        orderMin: null,
        orderMax: null,
        rate: 0.0,
        effectiveDate: '',
        expirationDate: null,
        minChargeUnit: null,
        minChargeCostElement: null,
        workCenterId: null,
        workCenterCode: '',
        minutes: null,
        updateDate  : null,
        updateUser  : null,
        description2: null
    };

    let initialLazyState: LazyState | DataTablePageEvent | DataTableFilterEvent = {
        currentPageNumber: 0,
        firstRow: 0,
        lastRow: 0,
        first: 0,
        rows: 25,
        page: 0,
        filter: null
    };
    const [lazyState, setLazyState] = useState<LazyState | DataTablePageEvent | DataTableFilterEvent>(initialLazyState);
    const [totalRateDefaults, setTotalRateDefaults] = useState(0);
    const [currentPageNumber, setPageNumber] = useState(0);
    const [firstIdNumber, setFirstIdNumber] = useState(0);
    const [lastIdNumber, setLastIdNumber] = useState(0);

    const [listValuesRD, setListValuesRD] = useState<RateDefault[]>([]);
    const [singleValueRD, setSingleValueRD] = useState<RateDefault>(emptyRD);
    const [loadingRD, setLoadingRD] = useState(true);
    const [globalFilterRD, setGlobalFilterRD] = useState('');
    const [costElements, setCostElements] = useState<CostElement[]>([]);
    const [workCenters, setWorkCenters] = useState<WorkCenter[]>([]);
    const [formulaOptions, setFormulaOptions] = useState<FormulaOption[]>([]);
    const [factories, setFactories] = useState<Factory[]>([]);
    const dtRD = useRef<any>(null);
    const isNewRD = useRef(false);
    const formRD = useForm();
    const errorsRD = formRD.formState.errors;
    const toastRD = useRef<any>(null);
    const [deleteDialogRD, setDeleteDialogRD] = useState(false);
    const [materialGroups, setMaterialGroups] = useState<SAPMaterialGroup[]>([]);
    const [materialGroupDescription, setMaterialGroupDescription] = useState<string | undefined>('');
    type FieldNames = 'costElementId' | 'factoryId' | 'formulaOptionId' | 'materialGroupId' | 'letterSize' | 'numberOfColors' | 'color' | 'orderMin' | 'orderMax' | 'rate' | 'effectiveDate' | 'expirationDate' | 'minChargeUnit' | 'minChargeCostElement' | 'workCenterId' | 'minutes';
    const fieldOrder: FieldNames[] = ['costElementId', 'factoryId', 'formulaOptionId', 'materialGroupId', 'letterSize', 'numberOfColors', 'color', 'orderMin', 'orderMax', 'rate', 'effectiveDate', 'expirationDate', 'minChargeUnit', 'minChargeCostElement', 'workCenterId', 'minutes'];
    const [selectedFormula, setSelectedFormula] = useState<number | null>(null);
    const [selectedCostElement, setSelectedCostElement] = useState<number | null>(null);
    const [selectedFactory, setSelectedFactory] = useState<number | null>(null);
    const [sortField, setSortField] = useState<string>('');
    const [sortOrder, setSortOrder] = useState<0 | 1 | -1 | null | undefined>(null);    
    const errorMessage = useRef<string>('');
    const { accounts } = useMsal();

    useEffect(() => {
        BomCostingService.getAllSAPMaterialGroup().then(data => setMaterialGroups(data));
        getRateDefaults();
        BomCostingService.getAllCostElements().then((data: CostElement[]) => {
            setCostElements(data);
        });
        BomCostingService.getAllFactories().then((data: Factory[]) => {
            setFactories(data);
        });
        BomCostingService.getAllFormulaOptions().then((data: FormulaOption[]) => {
            setFormulaOptions(data);
        });
        BomCostingService.getAllWorkCenters().then((data: WorkCenter[]) => setWorkCenters(data));

    }, [lazyState, sortOrder]);

    const getRateDefaults = () => {
        let _lazyState = { ...lazyState };
        _lazyState.currentPageNumber = currentPageNumber;
        _lazyState.firstRow = firstIdNumber;
        _lazyState.lastRow = lastIdNumber;
        _lazyState.filter = globalFilterRD;
        _lazyState.sortField = sortField;
        _lazyState.sortOrder = sortOrder;        
        setPageNumber(_lazyState.page);

        BomCostingService.getAllRateDefaultsLazy(_lazyState).then((data: RateDefaultList) => {
            if (data.totalRecords > 0) {
                setListValuesRD(data.rateDefaults);
                setFirstIdNumber(data.rateDefaults[0].id);
                let _lastOrder = [...data.rateDefaults].pop();
                if(_lastOrder){
                    setLastIdNumber(_lastOrder.id);
                    setTotalRateDefaults(data.totalRecords);
                    setLoadingRD(false);
                }
            } else {
                setListValuesRD([]);
                setFirstIdNumber(0);
                setLastIdNumber(0);
                setTotalRateDefaults(0);
                setLoadingRD(false);
            }
        });
    }

    const onPage = (event: DataTablePageEvent) => {
        setLazyState(event);
    };

    const onFilter = (event: DataTableFilterEvent) => {
        event['filter'] = globalFilterRD;
        setLazyState(event);
    };

    const onSort = (event: DataTableStateEvent) => {
        setSortField(event.sortField);
        setSortOrder(event.sortOrder);
    };
    
    const exportRateDefaults = () => {
        let originalRateDefaultData = [...dtRD.current.props.value];
        let _lazyState = { ...lazyState };
        _lazyState.rows = 0;

        BomCostingService.getAllRateDefaultsLazy(_lazyState).then((data: RateDefaultList) => {
            dtRD.current.props.value = data.rateDefaults;
            dtRD.current.exportCSV();
        });

        dtRD.current.props.value = originalRateDefaultData;
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export" onClick={(e) => {exportRateDefaults(); e.stopPropagation();}} />
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" onInput={(e) => {
                    setGlobalFilterRD((e.target as HTMLInputElement).value);
                    if ((e.target as HTMLInputElement).value === '') { 
                        setLazyState(initialLazyState);
                    }
                    }} placeholder="Search..." />
            </IconField>                
        </div>
    );

    const getMaterialGroupDescription = (id: number, isEdit: boolean) => {
        let _materialGroups = [...materialGroups];
        let _materialGroupDescription = _materialGroups.filter((v) => v.id === id).map((val) => { return val.description; })[0];
        setTimeout(() => setMaterialGroupDescription(_materialGroupDescription), 0);
    };

    function convertToISODateString(dateString: string): string {
        const isoDate = new Date(dateString);

        const formattedDate = isoDate.toISOString().split('T')[0];

        return formattedDate;
    }

    const costElementIdTemplate = (rowData: RateDefault) => costElements.find(ce => ce.id === rowData.costElementId)?.description;
    const formulaOptionIdTemplate = (rowData: RateDefault) => formulaOptions.find(fo => fo.id === rowData.formulaOptionId)?.optionName;
    const factoryIdTemplate = (rowData: RateDefault) => factories.find(fa => fa.id === rowData.factoryId)?.sapReference;
    const materialGroupTemplate = (rowData: RateDefault) => materialGroups.filter(val => val.id === rowData.materialGroupId).map((e) => { 
        return e.materialGroup + ' - ' + e.description;
    });
    const description2Template = (rowData: RateDefault) => rowData.description2;
    const letterSizeTemplate = (rowData: RateDefault) => rowData.letterSize;
    const numberOfColorsTemplate = (rowData: RateDefault) => rowData.numberOfColors;
    const colorTemplate = (rowData: RateDefault) => rowData.color;
    const orderMinTemplate = (rowData: RateDefault) => rowData.orderMin;
    const orderMaxTemplate = (rowData: RateDefault) => rowData.orderMax;
    const rateTemplate = (rowData: RateDefault) => rowData.rate;
    const effectiveDateTemplate = (rowData: RateDefault) => rowData.effectiveDate;
    const expirationDateTemplate = (rowData: RateDefault) => rowData.expirationDate;
    const minChargeUnitBodyTemplate = (rowData: RateDefault) => { return rowData.minChargeUnit }
    const minChargeCostElementBodyTemplate = (rowData: RateDefault) => { return rowData.minChargeCostElement }
    const workCenterIdBodyTemplate = (rowData: RateDefault) => { return workCenters.find(wc => wc.id === rowData.workCenterId)?.code; }
    const minutesBodyTemplate = (rowData: RateDefault) => { return rowData.minutes }

    const clearNew = () => {
        formRD.reset();
        resetFollowingFields('costElementId');
        setSelectedCostElement(null);
    }

    const getErrorMessage = (name: string) => {
        return errorsRD[name] ? <small className="p-error">{(errorsRD[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const findIdenticalRateDefault = (listValuesRD: any[], _value: any) => {
        return listValuesRD.find((rd) => {
            if (
                rd.costElementId === _value.costElementId &&
                rd.factoryId === _value.factoryId &&
                rd.formulaOptionId === _value.formulaOptionId &&
                rd.materialGroupId === _value.materialGroupId &&
                (rd.expirationDate === null || rd.expirationDate === '' || rd.expirationDate === undefined)
            ) {
                switch (_value.formulaOptionId) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 8:
                    case 4:
                        return true;
                    case 5:
                    case 10:
                        return rd.letterSize === _value.letterSize;
                    case 6:
                        return rd.numberOfColors === _value.numberOfColors;
                    case 7:
                        return rd.orderMin === _value.orderMin && rd.orderMax === _value.orderMax;
                    case 9:
                        return rd.color === _value.color &&
                            rd.orderMin === _value.orderMin &&
                            rd.orderMax === _value.orderMax;
                    default:
                        return false;
                }
            }
            return false;
        });
    };

    const validateRate = (_value: RateDefault): boolean => {
        let isValid = false;

        if (_value.rate >= 0) {
            isValid = true;
        } else {
            errorMessage.current = 'Rate must be equal or greater than 0.';
            return false;
        }
        return isValid;
    }

    const validateByLetterSize = (_value: RateDefault): boolean => {
        let isValid = false;

        if (_value.letterSize as number >= 0) {
            isValid = true;
        } else {
            errorMessage.current = 'Letter size must be equal or greater than 0.';
            return false;
        }

        if (validateRate(_value)) {
            isValid = true;
        } else {
            return false;
        }

        return isValid;
    }

    const validateByColors = (_value: RateDefault): boolean => {
        let isValid = false;

        if (_value.numberOfColors as number >= 0) {
            isValid = true;
        } else {
            errorMessage.current = 'Number of colors must be equal or greater than 0.';
            return false;
        }

        if (validateRate(_value)) {
            isValid = true;
        } else {
            return false;
        }

        return isValid;
    }

    const validateByOrderMinMax = (listValuesRD: RateDefault[], _value: RateDefault): boolean => {
        let isValid = false;
        const orderMatches = listValuesRD.filter((entry) =>
            entry.factoryId === _value.factoryId &&
            entry.formulaOptionId === _value.formulaOptionId &&
            entry.costElementId === _value.costElementId
        );

        const maxOrderMax = orderMatches.length === 0 ? -1 : Math.max(...orderMatches.map((entry) => entry.orderMax ?? 0));

        if ((_value.orderMin as number) > maxOrderMax) {
            isValid = true;
        } else {
            errorMessage.current = 'Min Quantity must be greater than the actual max quantity';
            return false;
        }

        if ((_value.orderMax ?? 0) > (_value.orderMin ?? 0)) {
            isValid = true;
        } else {
            errorMessage.current = 'Max Quantity must be greater than min quantity';
            return false;
        }

        if ((_value.orderMin ?? 0) >= 0) {
            isValid = true;
        } else {
            errorMessage.current = 'Min Quantity must be equal or greater than 0';
            return false;
        }

        if (validateRate(_value)) {
            isValid = true;
        } else {
            return false;
        }

        return isValid;
    }

    const validateByColorOrderMinMax = (listValuesRD: RateDefault[], _value: RateDefault): boolean => {
        let isValid = false;
        const colorMatches = listValuesRD.filter((entry) =>
            entry.color === _value.color &&
            entry.factoryId === _value.factoryId &&
            entry.formulaOptionId === _value.formulaOptionId &&
            entry.costElementId === _value.costElementId
        );

        const maxOrderMax = colorMatches.length === 0 ? -1 : Math.max(...colorMatches.map((entry) => entry.orderMax ?? 0));

        if ((_value.orderMin as number) > maxOrderMax) {
            isValid = true;
        } else {
            errorMessage.current = 'Min Quantity must be greater than the actual max quantity';
            return false;
        }

        if ((_value.orderMax ?? 0) > (_value.orderMin ?? 0)) {
            isValid = true;
        } else {
            errorMessage.current = 'Max Quantity must be greater than min quantity';
            return false;
        }

        if ((_value.orderMin ?? 0) >= 0) {
            isValid = true;
        } else {
            errorMessage.current = 'Min Quantity must be equal or greater than 0';
            return false;
        }

        if (validateRate(_value)) {
            isValid = true;
        } else {
            return false;
        }

        return isValid;
    }

    const runValidations = async (_value: RateDefault): Promise<boolean> => {
        switch (_value.formulaOptionId) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 8:
            case 4:
                return validateRate(_value);
            case 5:
            case 10:
                return validateByLetterSize(_value);
            case 6:
                return validateByColors(_value);
            case 7:
                return validateByOrderMinMax(listValuesRD, _value);
            case 9:
                return validateByColorOrderMinMax(listValuesRD, _value);
            default:
                return false;
        }
    }

    const onSubmit = async (data: any) => {
        isNewRD.current = true;
        let _value = { ...singleValueRD };
        _value.costElementId = data.costElementId;
        _value.formulaOptionId = data.formulaOptionId;
        _value.factoryId = data.factoryId;
        _value.materialGroupId = data.materialGroupId;
        _value.letterSize = data.letterSize;
        _value.numberOfColors = data.numberOfColors;
        _value.color = data.color;
        _value.orderMin = data.orderMin
        _value.orderMax = data.orderMax
        _value.rate = data.rate;
        _value.effectiveDate = data.effectiveDate;
        _value.expirationDate = data.expirationDate;
        _value.minChargeUnit = data.minChargeUnit;
        _value.minChargeCostElement = data.minChargeCostElement;
        _value.minutes = data.minutes;

        // Find an identical object, taking formulaOptionId into account
        const identicalRateDefault = findIdenticalRateDefault(listValuesRD, _value);

        // If identical, update the old one adding a expiration date and create the new rateDefault
        if (identicalRateDefault) {
            const newEffectiveDate = new Date(_value.effectiveDate);
            newEffectiveDate.setDate(newEffectiveDate.getDate() - 1);
            const adjustedExpirationDate = `${newEffectiveDate.getFullYear()}-${String(newEffectiveDate.getMonth() + 1).padStart(2, '0')}-${String(newEffectiveDate.getDate()).padStart(2, '0')}`;

            identicalRateDefault.expirationDate = adjustedExpirationDate;
            await update(identicalRateDefault);
            await save(_value);
            clearNew();
            return;
        }

        // If not identical, run validations according their formula options
        const isValid = await runValidations(_value);

        if (isValid) {
            await save(_value)
            clearNew();
        } else {
            toastRD.current.show({ severity: 'error', summary: 'Failed', detail: errorMessage.current, life: 3000 });
        }
    };

    const save = (value: RateDefault): Promise<void> => {
        if (accounts[0]){
            value.updateDate = new Date().toISOString();
            value.updateUser = accounts[0].username;
        }
        return new Promise((resolve, reject) => {
            let _listValues = [...listValuesRD];
            BomCostingService.addRateDefault(value).then((data) => {
                if (data) {
                    _listValues.push(data);
                    _listValues = _listValues.map(rd => ({
                        ...rd,
                        effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                        expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                    }))
                    setListValuesRD(_listValues);
                    toastRD.current.show({ severity: 'success', summary: 'Successful', detail: 'Rate Default Created', life: 3000 });
                    setSingleValueRD(emptyRD);
                    resolve();
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Rate Default', life: 3000 });
                    reject(new Error("Failed to Create Rate Default"));
                }
            });
        });
    }

    const update = (value: RateDefault): Promise<void> => {
        if (accounts[0]){
            value.updateDate = new Date().toISOString();
            value.updateUser = accounts[0].username;
        }
        return new Promise((resolve, reject) => {
            let _listValues = [...listValuesRD];
            BomCostingService.updateRateDefault(value).then((data) => {
                if (data) {
                    let index = _listValues.findIndex(v => v.id === value.id);
                    _listValues[index] = value;
                    _listValues = _listValues.map(rd => ({
                        ...rd,
                        effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                        expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                    }))
                    setListValuesRD(_listValues);
                    toastRD.current.show({ severity: 'success', summary: 'Successful', detail: 'Rate Default update', life: 3000 });
                    setSingleValueRD(emptyRD);
                    resolve();
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Rate update', life: 3000 });
                    reject(new Error("Failed to Update Rate Default"));
                }
            });
        });
    }

    const rowEditorTemplate = (rowData: RateDefault) => {
        return (
            <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteRD(rowData)} to={''}></Link>
        );
    }

    const hideDeleteDialogRD = () => {
        setDeleteDialogRD(false);
    };

    const confirmDeleteRD = (value: RateDefault) => {
        setSingleValueRD(value);
        setDeleteDialogRD(true);
    }

    const deleteRow = () => {
        let _listValues = listValuesRD.filter((val) => val.id !== singleValueRD.id);
        BomCostingService.deleteRateDefault(singleValueRD.id).then((data: boolean) => {
            if (data) {
                setListValuesRD(_listValues);
                setDeleteDialogRD(false);
                setSingleValueRD(emptyRD);
                toastRD.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
            } else {
                toastRD.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
            }
        });

    };

    const deleteDialogFooterRD = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialogRD} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    const resetFollowingFields = (changedField: FieldNames) => {
        const fieldIndex = fieldOrder.indexOf(changedField);

        if (fieldIndex === -1) {
            return;
        }

        const fieldsToReset = fieldOrder.slice(fieldIndex + 1);

        fieldsToReset.forEach((field) => {
            if (field === 'formulaOptionId') {
                setSelectedFormula(null);
            }
            if (field === 'factoryId') {
                setSelectedFactory(null);
            }
            formRD.setValue(field, null);
        });
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === '.') {
          const inputElem = e.target as HTMLInputElement;
          if (inputElem.value === '' || inputElem.value === null) {
            inputElem.value = '0.';
            e.preventDefault();
          }
        }
      };

    return (
        <>
            <Toast ref={toastRD} />

            <Panel header="Add Rate Default" className="addPanel mb-2 -ml-2">
                <form onSubmit={formRD.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-fixed">
                            <Controller
                                name="costElementId"
                                control={formRD.control}
                                rules={{
                                    required: 'Cost Element is required.'
                                }}
                                render={({ field, fieldState }) => (

                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Cost Element *</label>
                                        <Dropdown value={field.value} options={costElements.filter((costElement) => costElement.allowFormulaCost === true)} optionLabel="description" optionValue="id" showClear className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                setSelectedCostElement(e.value);
                                                resetFollowingFields('costElementId');
                                            }} placeholder="Select..." />
                                        {getErrorMessage('costElementId')}
                                    </React.Fragment>
                                )}
                            />
                        </div>

                        {selectedCostElement != null && (
                            <div className="field col-fixed">
                                <Controller
                                    name="factoryId"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Factory Id is required.'
                                    }}
                                    render={({ field, fieldState }) => (

                                        <React.Fragment>
                                            <label htmlFor={field.name} className="font-bold text-xs">Plant/Vendor *</label>
                                            <Dropdown value={field.value} options={factories.filter(factory => factory.sapReference !== null && factory.sapReference !== undefined && factory.sapReference !== '')} optionLabel="sapReference" optionValue="id" showClear className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value); setSelectedFactory(e.value); resetFollowingFields('factoryId'); }} placeholder="Select..." />
                                            {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{factories.find(ce => ce.id === field.value)?.description}</small> : <></>}
                                            {getErrorMessage('factoryId')}
                                        </React.Fragment>
                                    )}
                                />
                            </div>
                        )}

                        {selectedCostElement != null && selectedFactory != null && (
                            <div className="field col-fixed">
                                <Controller
                                    name="formulaOptionId"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Formula Option is required.'
                                    }}
                                    render={({ field, fieldState }) => (

                                        <React.Fragment>
                                            <label htmlFor={field.name} className="font-bold text-xs">Formula Option *</label>
                                            <Dropdown value={field.value} options={formulaOptions} optionLabel="optionName" optionValue="id" showClear className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value); setSelectedFormula(e.value); resetFollowingFields('formulaOptionId'); }} placeholder="Select..." />
                                            {getErrorMessage('formulaOptionId')}
                                        </React.Fragment>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula != null && (
                            <div className="field col-fixed">
                                <Controller
                                    name="materialGroupId"
                                    control={formRD.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Material Group</label>
                                            <Dropdown inputId={field.name} value={field.value} options={materialGroups} optionLabel="materialGroup" optionValue="id" className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { getMaterialGroupDescription(e.value, false); field.onChange(e.value); }} showClear filter filterBy="materialGroup" placeholder="Material Group" virtualScrollerOptions={{ itemSize: 50 }} />
                                            {field.value !== null ? <small className="text-primary">{materialGroupDescription}</small> : <></>}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {(selectedFormula === 5 || selectedFormula === 10) && (
                            <div className="field col-1">
                                <Controller
                                    name="letterSize"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Letter Size is required'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Letter Size *</label>
                                            <InputNumber inputRef={field.ref} name={field.name} value={field.value} min={0} minFractionDigits={0} maxFractionDigits={3} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Size" />
                                            {getErrorMessage('letterSize')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula === 6 && (
                            <div className="field col-1">
                                <Controller
                                    name="numberOfColors"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Number Of Colors is required'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Colors *</label>
                                            <InputNumber inputRef={field.ref} name={field.name} value={field.value} maxLength={50} className={classNames({ 'p-invalid border-left-10': fieldState.error })} min={0} onChange={(e) => field.onChange(e.value)} placeholder="Colors" />
                                            {getErrorMessage('numberOfColors')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula === 9 && (
                            <div className="field col-1">
                                <Controller
                                    name="color"
                                    control={formRD.control}
                                    defaultValue=""
                                    rules={{
                                        required: 'Color is required'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Color *</label>
                                            <InputText id={field.name} name={field.name} value={field.value} maxLength={50} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} placeholder="Color" />
                                            {getErrorMessage('color')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {(selectedFormula === 9 || selectedFormula === 7) && (
                            <div className="field col-1">
                                <Controller
                                    name="orderMin"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Order Min is required'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Min Quantity *</label>
                                            <InputNumber inputRef={field.ref} name={field.name} value={field.value} maxLength={50} className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value) }} placeholder="Min" />
                                            {getErrorMessage('orderMin')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {(selectedFormula === 9 || selectedFormula === 7) && (
                            <div className="field col-1">
                                <Controller
                                    name="orderMax"
                                    control={formRD.control}
                                    rules={{ 
                                        required: 'Order Max is required'
                                    }}
                                    render={({ field, fieldState }) => ( 
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Max Quantity *</label>
                                            <InputNumber inputRef={field.ref} name={field.name} value={field.value} maxLength={50} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Max" />
                                            {getErrorMessage('orderMax')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        
                        {(selectedFormula === 2 || selectedFormula === 3) && (
                            <div className="field col-1">
                                <Controller
                                    name="minutes"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Sublimation minutes are required.',
                                        validate: (value) => (value >= 0) || 'Enter a valid number.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Sub Minutes *</label>
                                            <InputNumber
                                                id={field.name}
                                                inputRef={field.ref}
                                                value={field.value}
                                                onBlur={field.onBlur}
                                                min={0}
                                                onChange={(e) => field.onChange(e.value)}
                                                inputClassName={classNames({ 'p-invalid': fieldState.error })}
                                                minFractionDigits={0} maxFractionDigits={3}
                                            />
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula != null && (
                            <div className="field col-1">
                                <Controller
                                    name="rate"
                                    control={formRD.control}
                                    rules={{
                                        required: 'Rate is required.',
                                        validate: (value) => {
                                            if (value < 0 || value > 9999999999.9999) {
                                                return 'Must be between 0 and 9.999.999.999.9999';
                                              }
                                            return true;
                                          },
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Rate *</label>
                                            <InputNumber id={field.name} name={field.name} inputRef={field.ref} useGrouping={false} value={field.value} onBlur={field.onBlur} onChange={(e) => field.onChange(e.value)} onKeyDown={handleKeyDown} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} maxFractionDigits={4} placeholder="Rate" />
                                            {getErrorMessage('rate')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula !== null && selectedFormula > 0 && (
                            <div className="field col-1">
                                <Controller
                                    name="minChargeUnit"
                                    control={formRD.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">$ Min / Unit</label>
                                            <InputNumber
                                                id={field.name}
                                                inputRef={field.ref}
                                                value={field.value}
                                                onBlur={field.onBlur}
                                                min={0}
                                                onChange={(e) => field.onChange(e.value)}
                                                inputClassName={classNames({ 'p-invalid': fieldState.error })}
                                                minFractionDigits={0} maxFractionDigits={3}
                                            />
                                            {getErrorMessage('minChargeUnit')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula !== null && selectedFormula > 0 && (
                            <div className="field col-1">
                                <Controller
                                    name="minChargeCostElement"
                                    control={formRD.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">$ Min / Elem</label>
                                            <InputNumber
                                                id={field.name}
                                                inputRef={field.ref}
                                                value={field.value}
                                                onBlur={field.onBlur}
                                                min={0}
                                                onChange={(e) => field.onChange(e.value)}
                                                inputClassName={classNames({ 'p-invalid': fieldState.error })}
                                                minFractionDigits={0} maxFractionDigits={3}
                                            />
                                            {getErrorMessage('minChargeCostElement')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula != null && (
                            <div className="field col-1">
                                <Controller
                                    name="effectiveDate"
                                    control={formRD.control}
                                    defaultValue={''}
                                    rules={{
                                        required: 'Effective date is required'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Effective Date *</label>
                                            <Calendar id={field.name} name={field.name} value={field.value} minDate={new Date()} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e: FormEvent<Date, SyntheticEvent<Element, Event>>) => field.onChange(e.target.value)} dateFormat="yy-mm-dd" placeholder="Effective" />
                                            {getErrorMessage('effectiveDate')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula != null && (
                            <div className="field col-1">
                                <Controller
                                    name="expirationDate"
                                    control={formRD.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Expiration Date</label>
                                            <Calendar id={field.name} name={field.name} value={field.value} minDate={new Date()} onChange={(e: FormEvent<Date, SyntheticEvent<Element, Event>>) => field.onChange(e.target.value)} dateFormat="yy-mm-dd" placeholder="Expiration" />
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        <div className="field field-buttons col pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dtRD} className="-ml-2" lazy value={listValuesRD}
                dataKey="id" size="small" rowHover={true} loading={loadingRD} header={header}
                scrollable scrollHeight="calc(100vh - 28.2rem)"
                paginator rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                first={lazyState.first} rows={lazyState.rows} totalRecords={totalRateDefaults}
                onPage={onPage} onFilter={onFilter}
                onSort={onSort} sortField={sortField} sortOrder={sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                csvSeparator=","
                globalFilter={globalFilterRD}
                emptyMessage="No rate default records found.">
                <Column field="costElementId" header="Cost Element" sortable sortField="CostElementDescription" body={costElementIdTemplate} align="center" alignHeader="center" exportable={false}></Column>
                <Column field="costElementDescription" header="Cost Element" style={{ display: 'none' }}></Column>
                <Column field="factoryId" header="Plant/Vendor" sortable sortField="SapReference" body={factoryIdTemplate} align="center" alignHeader="center" exportable={false}></Column>
                <Column field="sapReference" header="Plant/Vendor" style={{ display: 'none' }}></Column>
                <Column field="formulaOptionId" header="Formula" sortable sortField="FormulaOptionName" body={formulaOptionIdTemplate} align="center" alignHeader="center" exportable={false}></Column>
                <Column field="formulaOptionName" header="Formula" style={{ display: 'none' }}></Column>
                <Column field="materialGroupId" header="Material Group" sortable sortField="MaterialCapacityGroup" body={materialGroupTemplate} align="center" alignHeader="center" exportable={false}></Column>
                <Column field="materialCapacityGroup" header="Material Group" style={{ display: 'none' }}></Column>
                <Column field="description2" header="Material Group Desc 2" sortable sortField="Description2" body={description2Template} align="center" alignHeader="center"></Column>
                <Column field="letterSize" header="Letter Size" sortable sortField="LetterSize" body={letterSizeTemplate} align="center" style={{ width: '5px' }} alignHeader="center"></Column>
                <Column field="numberOfColors" header="Colors" sortable sortField="NumberOfColors" body={numberOfColorsTemplate} align="center" alignHeader="center"></Column>
                <Column field="color" header="Color" sortable sortField="Color" body={colorTemplate} align="center" alignHeader="center"></Column>
                <Column field="orderMin" header="Min Quantity" sortable sortField="OrderMin" body={orderMinTemplate} align="center" style={{ width: '5px' }} alignHeader="center"></Column>
                <Column field="orderMax" header="Max Quantity" sortable sortField="OrderMax" body={orderMaxTemplate} align="center" style={{ width: '5px' }} alignHeader="center"></Column>
                <Column field="rate" header="Rate" sortable sortField="Rate" body={rateTemplate} align="center" alignHeader="center"></Column>
                <Column field="effectiveDate" header="Effective" sortable sortField="EffectiveDate" body={effectiveDateTemplate} align="center" alignHeader="center"></Column>
                <Column field="expirationDate" header="Expiration" sortable sortField="ExpirationDate" body={expirationDateTemplate} align="center" alignHeader="center"></Column>
                <Column field="minChargeUnit" header="Min Charge / Unit" body={minChargeUnitBodyTemplate} align="center" alignHeader="center"></Column>
                <Column field="minChargeCostElement" header="Min Charge / Element" body={minChargeCostElementBodyTemplate} align="center" alignHeader="center"></Column>
                <Column field="workCenterId" header="Work Center" body={workCenterIdBodyTemplate} align="center" alignHeader="center" exportable={false}></Column>
                <Column field="workCenterCode" header="Work Center" style={{ display: 'none' }}></Column>
                <Column field="minutes" header="Minutes" body={minutesBodyTemplate} align="center" alignHeader="center"></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialogRD} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooterRD} onHide={hideDeleteDialogRD}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValueRD && (
                        <span>
                            Are you sure you want to delete <b>{singleValueRD.costElementDescription} - {singleValueRD.sapReference} - {singleValueRD.rate}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}